import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { templateView,templateEditView } = Views;

const locationRouter = {
  path: "/template",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "templates",
      name: "Templates",
      component: templateView,
      meta: {
        requiresAuth: true,
      },
    },
     {
      path: "templates/edit/:id",
      name: "TemplateEdit",
      component: templateEditView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default locationRouter;
